import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SnackbarConfig, TiimeSnackbarService } from 'tiime-components';

import { sharedInjector } from '@modules/shared/shared-injector';

export function ApiAlertError(
  statusBlackList = [HttpStatusCode.Forbidden, HttpStatusCode.NotFound, HttpStatusCode.ServiceUnavailable]
): MethodDecorator {
  return (_target: () => void, _propertyKey: string, descriptor: PropertyDescriptor) => {
    const original = descriptor.value;
    descriptor.value = function (...args: any[]) {
      return original.apply(this, args).pipe(
        catchError(error => {
          if (
            error instanceof HttpErrorResponse &&
            error.error &&
            error.error.error_description &&
            !statusBlackList.includes(error.status)
          ) {
            sharedInjector
              .get(TiimeSnackbarService)
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              .open(error.error.error_description ? error.error.error_description : 'Erreur', SnackbarConfig.error);
          } else if (error.error instanceof Blob && error.error.type === 'application/json') {
            const reader = new FileReader();
            reader.onloadend = () => {
              if (reader.result) {
                const fileError = JSON.parse(reader.result as string);
                if (fileError.error_description) {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                  sharedInjector.get(TiimeSnackbarService).open(fileError.error_description, SnackbarConfig.error);
                }
              }
            };
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            reader.readAsText(error.error);
          }

          return throwError(error);
        })
      );
    };
    return descriptor;
  };
}
